import { useEffect, useState } from "react";
import { AutocompleteInput } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomFilterSelect from "./CustomFilterSelect";

const FilterEmployerCompany = (props: any) => {
  const [companyList, setCompanyList] = useState([]);
  useEffect(() => {
    const fetchCompanyList = async () => {
      const reqUrl = "employers/shortList";
      await sendRequest(reqUrl, {
        id: 1,
        data: {
          status: 1, //only active products
        },
      }).then((response) => {
        if (response) {
          setCompanyList(response);
        }
      });
    };
    fetchCompanyList();
  }, []);

  const companyData = [
    { id: "", name: "Please select" },
    ...companyList.map((company: any) => {
      return { id: company.sName, name: company.sName };
    }),
  ];
  const authrole = localStorage?.getItem("authrole")?.toString();
  return (
    <CustomFilterSelect
      label="Referral Source"
      source="employment_company"
      choices={companyData}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterEmployerCompany;
